import React from 'react';
import {
  Box,
  Container,
  Typography,
  CircularProgress,
  Paper,
} from "@mui/material";

interface LoadingScreenProps {
  message?: string;
  subtitle?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = "Estamos levantando la aplicación",
  subtitle = "Por favor, espere un momento mientras el servidor se inicia..."
}) => {
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        minWidth: "100vw",
        height: "100vh",
        background: "linear-gradient(90deg, #fff 0%,rgb(239, 234, 255) 30%, #fff5ea 70%, #fff 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          maxWidth: "400px",
          px: 3,
        }}
      >
        {/* Logo o ícono */}
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "linear-gradient(135deg,rgb(74, 84, 122) 0%, #364889 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 4,
            boxShadow: "0 8px 32px rgba(33, 10, 235, 0.3)",
            animation: "pulse 2s infinite",
            "@keyframes pulse": {
              "0%": {
                transform: "scale(1)",
                boxShadow: "0 8px 32px rgba(33, 10, 235, 0.3)",
              },
              "50%": {
                transform: "scale(1.05)",
                boxShadow: "0 12px 40px rgba(33, 10, 235, 0.4)",
              },
              "100%": {
                transform: "scale(1)",
                boxShadow: "0 8px 32px rgba(33, 10, 235, 0.3)",
              },
            },
          }}
        >
          <CircularProgress
            size={40}
            sx={{
              color: "white",
              "& .MuiCircularProgress-circle": {
                strokeLinecap: "round",
              },
            }}
          />
        </Box>

        {/* Título */}
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 600,
            color: "#2c3e50",
            mb: 2,
            fontSize: { xs: "1.5rem", sm: "2rem" },
          }}
        >
          {message}
        </Typography>

        {/* Subtítulo */}
        <Typography
          variant="body1"
          sx={{
            color: "#7f8c8d",
            lineHeight: 1.6,
            fontSize: { xs: "0.9rem", sm: "1rem" },
            maxWidth: "300px",
          }}
        >
          {subtitle}
        </Typography>

        {/* Indicador de puntos animados */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            mt: 3,
            "& > div": {
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#364889",
              animation: "bounce 1.4s infinite ease-in-out both",
              "&:nth-of-type(1)": { animationDelay: "-0.32s" },
              "&:nth-of-type(2)": { animationDelay: "-0.16s" },
              "&:nth-of-type(3)": { animationDelay: "0s" },
            },
            "@keyframes bounce": {
              "0%, 80%, 100%": {
                transform: "scale(0)",
              },
              "40%": {
                transform: "scale(1)",
              },
            },
          }}
        >
          <div></div>
          <div></div>
          <div></div>
        </Box>
      </Box>
    </Container>
  );
};

export default LoadingScreen; 